import {request} from "./request";

export function GetSportsMeetGroup(category, sgroup) {
  return request({
    url: 'SportsMeet/GetSportsMeetGroup',
    params: {
      category, sgroup
    }
  })
}

export function GetSportsMeetAthletList(gender, sgroup, category, progress) {
  return request({
    url: 'SportsMeet/GetSportsMeetAthletList',
    params: {
      gender, sgroup, category, progress
    }
  })
}

export function GetSportsMeetTitleList(gender, sgroup, category, progress) {
  return request({
    url: 'SportsMeet/GetSportsMeetTitleList',
    params: {
      gender, sgroup, category, progress
    }
  })
}

export function ChangeSportsMeetSerial(title, serial) {
  return request({
    url: 'SportsMeet/ChangeSportsMeetSerial',
    params: {
      title, serial
    }
  })
}

export function SportsMeetPromotion(list, gender, sgroup, category, new_progress, new_groups, title) {
  return request({
    url: 'SportsMeet/SportsMeetPromotion',
    method: 'post',
    params: {
      list, gender, sgroup, category, new_progress, new_groups, title
    }
  })
}

export function GetSerial(types) {
  return request({
    url: 'ydh/GetSerial',
    params: {
      types
    }
  })
}

export function DelAthletByIdList(idList) {
  return request({
    url: 'SportsMeet/DelAthletByIdList',
    params: {
      idList
    }
  })
}
export function GetSportsMeetMultiTypes() {
  return request({
    url: 'SportsMeet/GetSportsMeetMultiTypes',
  })
}
export function AddAthletesController(sName,sNum,gender,dep,number,sgroup,types,category,progress,groupNumber,serial,dc,title,) {
  return request({
    url: 'SportsMeet/AddAthletesController',
    params: {
      sName,sNum,gender,dep,number,sgroup,types,category,progress,groupNumber,serial,dc,title,
    }
  })
}
